module.exports = __webpack_public_path__ + "img/3x.29bdd2b.jpg";